import React from 'react';

const Header = (props) => {
    const { title, title2, title3 } = props;

    return (
        <div className='header-container'>
            <h1>{title}</h1>
            <p className="message" dangerouslySetInnerHTML={{__html: title2}} />
            <p className="message">{title3}</p>
        </div>
    )
}

export default Header;
